module.exports = __webpack_public_path__ + "img/34.1da566b3.png";